<template>
  <div class="lmp-block clearBoth">
    <table cellpadding="10" cellspacing="10">
      <thead>
      <tr class="tc">
        <th>号</th>
        <th>第一球</th>
        <th>第二球</th>
        <th>第三球</th>
        <th>第四球</th>
        <th>第五球</th>
        <th>第六球</th>
        <th>第七球</th>
        <th>第八球</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in tableData" :key="'table' + index">
        <td>
          <span v-if="item.list[0].lottery_type === 3" class="number2" :class="'numbernc' + item.title"></span>
	  <span v-else class="number3" :class="'number3' + item.title"></span>
        </td>
        <td v-for="(td, ind) in item.list" :key="'td' + ind">
          <g-switch-item
            :chip="chip" class="td-item" :type="4" :item="td" :isSelectAll="td.isSelectAll"  :key="key" :isWatch="false"/>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
  import mixin from '../mixins';
  import GSwitchItem from '../../c_game-switch/switch-item/g_switch-item1';
  import Vue from "../../../utils/bus"; // 纵向

  export default {
    name: "pk10_lmp",
    mixins: [mixin],
    components: {
      GSwitchItem
    },
 data(){
      return{
        ballNumberArray:['第一球','第二球','第三球','第四球','第五球','第六球','第七球','第八球'],
        key:1,
        numbers:0
      }
 },

    computed: {
      tableData() {
        this.data.vertical.forEach((item)=>{
         item.list.forEach((value)=>{
           value.isSelectAll=false;
         })
        })
        return this.data.vertical || [];
      }
    },
    created() {
      Vue.$on("changSelect", (item,checkboxArray)=> {
        this.tableData.forEach((it)=>{
          it.list.forEach((value,index)=>{
            value.isSelectAll=checkboxArray[index];
          });
          this.key=new Date().getMilliseconds();
        })
        this.numbers+=1;
        this.$store.state.ckboxflag=this.numbers;
      });
    }
  }
</script>

<style scoped lang="stylus">
  $border-color = #e6e6e6;
  .lmp-block
    width 100%
    font-size 13px

    table, thead, tbody
      width 100%

    th, td {
      padding 0
    }

    thead {
      > tr {
        border-top 1px solid $border-color
        background linear-gradient(#ffffff, #f0f0f0)
        font-weight bold
        border-left 1px solid $border-color

        > th {
          height 35px
        }

        > th:nth-of-type(1) {
          width 60px
        }
      }
    }

    tbody {
      border-right 1px solid $border-color
    }

    th, td {
      text-align center
      border-left 1px solid $border-color
      border-bottom 1px solid $border-color
      vertical-align middle
    }

    .td-item
      border none
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/gd_ha10/dh18.vue